const groupWalls = (collection) => {
  const entries = [];
  const byWallId = {};

  (collection || []).forEach((item) => {
    const { wallId } = item;
    if (!wallId) {
      entries.push({ type: 'item', item });
      return;
    }

    let group = byWallId[wallId];
    if (!group) {
      group = {
        type: 'wall',
        wallId,
        wallName: item.wallName,
        wallPreviewUrl: item.wallPreviewUrl,
        pieceCount: 0,
        items: [],
        discountItem: null
      };
      byWallId[wallId] = group;
      entries.push(group);
    }

    if (item.discountText) {
      group.discountItem = item;
    } else {
      group.items.push(item);
      group.pieceCount += 1;
    }
  });

  return entries;
};

export default groupWalls;
